/**
 * Convierte un Blob a base64 SIN el prefijo `data:...;base64,`, listo para viajar
 * en un body JSON. El backend lo decodifica con `Convert.FromBase64String`.
 */
export const blobToBase64 = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error);
    reader.onloadend = () => {
      // reader.result = "data:<mime>;base64,<datos>"; nos quedamos con <datos>.
      const result = reader.result as string;
      const comma = result.indexOf(',');
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.readAsDataURL(blob);
  });
